import styled from "styled-components";
import { ThemeType } from "../../../types/Theme";

export const ContainerMelhorEnvio = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    .textoMelhorEnvio{
      color: ${(props) => props.theme.colors.tertiary};
      text-align: left;
      padding: 5rem 0;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 30%;
        height: 2px;
        border-radius: 100%;
        background-color: ${(props) => props.theme.colors.elements};
      }
    }
    .tituloConfigMelhorEnvio{
      color: ${(props) => props.theme.colors.tertiary};
      font-weight: bold;
      margin-top: 2rem;
      text-align: left;
      padding-top: 4rem;
    }

    .containerInput {
      width: 40rem;
      @media (max-width: 768px) {
        width: 33rem;
      }
    }
    .ultimo{
      width: 40rem;
      @media (max-width: 768px) {
        width: 100%;
      }
    }
`;

export const ModalContainer = styled.div<{theme: ThemeType}>`
  padding: 2rem 5rem;
  .titulo{
    font-size: 3rem;
    text-align: center;
    font-weight: bold;
    color: ${({theme}) => theme.colors.secondary};
    margin-bottom: 2rem;
  }
  
  .texto{
    font-size: 2.4rem;
    text-align: justify;
    margin-bottom: 2rem;
  }
  .botoes{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .cancelar{
      font-size: 2.4rem;
      cursor: pointer; 
    }
  }
`;

export const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 0 2rem;
`;

export const Grids = styled.div`
padding: 2rem 0 4rem 0;
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  width: 100%;      
`;